import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about-us-case2.png")